// extracted by mini-css-extract-plugin
export default {"socialItem":"SocialList_socialItem__qpQYu","scrolled":"SocialList_scrolled__m4Eb+","socialList":"SocialList_socialList__Y0H2p"};